// Sentry — initialisation côté navigateur (client bundle).
// Fichier chargé automatiquement par Next.js (>= 15) sur tous les routes.
;globalThis["_sentryRouteManifest"] = "{\"isrRoutes\":[],\"dynamicRoutes\":[],\"staticRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.2.4";globalThis["_sentryRewritesTunnelPath"] = "/monitoring";import * as Sentry from '@sentry/nextjs';

const dsn = process.env.NEXT_PUBLIC_SENTRY_DSN;

// Active le Session Replay seulement si la variable d'env vaut "true".
// Par défaut : désactivé pour économiser le quota Sentry.
const enableReplay = process.env.NEXT_PUBLIC_SENTRY_ENABLE_REPLAY === 'true';

// Détection des bots/crawlers : ils génèrent du bruit (fetch échoue, APIs absentes,
// pas d'utilisateur derrière). On n'initialise pas Sentry pour eux.
const BOT_REGEX = /bot|crawler|spider|crawling|googlebot|bingbot|slurp|duckduckbot|baiduspider|yandexbot|sogou|exabot|facebot|ia_archiver|semrush|ahrefs|mj12bot|dotbot|seokicks|petalbot|applebot|linkedinbot|twitterbot|facebookexternalhit|whatsapp|telegrambot|discordbot|slackbot|pinterest|headlesschrome|phantomjs|lighthouse|chrome-lighthouse|pagespeed/i;

const isBot = typeof navigator !== 'undefined' && BOT_REGEX.test(navigator.userAgent || '');

const integrations: any[] = [
  // Remonte les `console.error` à Sentry (warnings restent silencieux).
  Sentry.captureConsoleIntegration({ levels: ['error'] }),
];
if (enableReplay) {
  integrations.push(
    Sentry.replayIntegration({
      // Masquage par défaut pour protéger les données utilisateur.
      maskAllText: true,
      blockAllMedia: true,
    }),
  );
}

if (dsn && !isBot) {
  Sentry.init({
    dsn,
    environment: process.env.NEXT_PUBLIC_SENTRY_ENV || process.env.NODE_ENV,

    sendDefaultPii: true,

    // 100% en dev pour tout voir, 10% en prod pour limiter le volume.
    tracesSampleRate: process.env.NODE_ENV === 'development' ? 1.0 : 0.1,

    // Session Replay (toggle via env)
    replaysSessionSampleRate: enableReplay ? 0.1 : 0,
    replaysOnErrorSampleRate: enableReplay ? 1.0 : 0,

    enableLogs: true,

    // Bruit connu : erreurs réseau transitoires, extensions navigateur, page unload.
    // Ces erreurs ne sont pas actionnables côté code.
    ignoreErrors: [
      'Failed to fetch',
      'NetworkError when attempting to fetch resource',
      'Load failed',
      'cancelled',
      'AbortError',
      'The user aborted a request',
      // Extensions navigateur communes
      'ResizeObserver loop limit exceeded',
      'ResizeObserver loop completed with undelivered notifications',
      'Non-Error promise rejection captured',
    ],
    denyUrls: [
      // Extensions navigateur
      /extensions\//i,
      /^chrome:\/\//i,
      /^chrome-extension:\/\//i,
      /^moz-extension:\/\//i,
    ],

    integrations,
  });
}

// Instrumente les transitions de navigation côté client.
export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
